import { useNavigate } from 'react-router-dom';
import { Button } from 'theme-ui';

export default function ClearTableFilter({ url, ml = '10px' }) {
    const navigate = useNavigate();
    return (
        <Button variant='PrimaryHeadBtn' onClick={() => navigate(url)} className='toggle-btn' sx={{ marginLeft: ml }}>
            Clear Filter
        </Button>
    )
}
